import { render, staticRenderFns } from "./FoulingEvents.vue?vue&type=template&id=33a4f2b6&"
import script from "./FoulingEvents.vue?vue&type=script&lang=js&"
export * from "./FoulingEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports